import { Controller } from "stimulus"
import tippy from 'tippy.js';

export default class extends Controller {
  static targets = []

  initTooltip(e) {
    // Calling function on hover and using target, because initialization generate tooltip content in advance;
    // And as we use turbo-frames(making call to server), it can cause issues with lots of tooltips on page
    tippy(e.target, {
      content: `<turbo-frame id='signature_preview' src=${e.target.dataset.contentSource}></turbo-frame>`,
      allowHTML: true,
      maxWidth: 'none',
      theme: 'light-border',
      trigger: 'mouseenter',
      placement: 'right'
    });
  }
}
